import { Component, Input, OnInit } from "@angular/core";
import { PopoverController } from "@ionic/angular";
import { GamesService } from "src/app/services/lobby/games.service";
import { LobbyService } from "src/app/services/lobby/lobby.service";
import { GameHubControllerService } from "src/app/services/gameHub/game-hub-controller";
import { Navigator} from "../../components/menu/navigator";
@Component({
  selector: "app-popover-available-games",
  templateUrl: "./popover-available-games.component.html",
  styleUrls: ["./popover-available-games.component.scss"],
})
export class PopoverAvailableGamesComponent implements OnInit {
  @Input() data: any;

  imagePath = "";

  constructor(
    private gameService: GamesService,
    private lobbyService: LobbyService,
    protected popoverCtrl: PopoverController,
    private gameHubControllerService: GameHubControllerService,
    private navigator: Navigator
  ) {
    this.imagePath = this.lobbyService.galleryImagePath;
  }

  ngOnInit() {
    //this.data.push(this.data[0]);
  }

  getGameImage(gameId) {
    const gameData = this.gameService.getGameById(gameId);
    return gameData?.imagename;
  }

  protected launchGameWithId(gameId) {
    this.navigator.dismissAll('');
    const gameData = this.gameService.getGameById(gameId);
    setTimeout(() => {
      this.gameHubControllerService.launchCasinoGame(gameData);
    }, 1000);
  }

  closePopover() {
     this.popoverCtrl.dismiss(true);
  }
}
